var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#3E7EEE",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#3E7EEE",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4375 27H36.5625C35.2625 27 34.2 28.05 34.2 29.35V30.525C34.2 31.825 35.25 32.875 36.55 32.875H42.4375C43.7375 32.875 44.7875 31.825 44.7875 30.525V29.35C44.8 28.05 43.7375 27 42.4375 27Z",
    fill: "#3E7EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.05 30.525C46.05 32.5125 44.425 34.1375 42.4375 34.1375H36.5625C34.575 34.1375 32.95 32.5125 32.95 30.525C32.95 29.825 32.2 29.3875 31.575 29.7125C29.8125 30.65 28.6125 32.5125 28.6125 34.65V46.4125C28.6125 49.4875 31.125 52 34.2 52H44.8C47.875 52 50.3875 49.4875 50.3875 46.4125V34.65C50.3875 32.5125 49.1875 30.65 47.425 29.7125C46.8 29.3875 46.05 29.825 46.05 30.525ZM43.675 40.4125L38.675 45.4125C38.4875 45.6 38.25 45.6875 38.0125 45.6875C37.775 45.6875 37.5375 45.6 37.35 45.4125L35.475 43.5375C35.1125 43.175 35.1125 42.575 35.475 42.2125C35.8375 41.85 36.4375 41.85 36.8 42.2125L38.0125 43.425L42.35 39.0875C42.7125 38.725 43.3125 38.725 43.675 39.0875C44.0375 39.45 44.0375 40.05 43.675 40.4125Z",
    fill: "#3E7EEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.b6f9c603bc9028eef922332d110275e8.svg";
export { ForwardRef as ReactComponent };